export default __webpack_public_path__ + "static/media/metal_reflection.58891b3b.png";